import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';
import AntGridScope, { buildGridScopeSegment } from './AntGridScope';

import AntGrid from './AntGrid';

export default forwardRef(function (props, ref) {
    const grid = useRef();

    // const reload = (defaultObj) => {
    //     if (grid.current) grid.current.load(defaultObj, true);
    // };

    const selectedRows = () => {
        if (grid.current) return grid.current.getSelectedRows();
        return [];
    };

    const getSelectedObjectId = () => {
        if (grid.current) return grid.current.getSelectedObjectId();
        return null;
    };

    useImperativeHandle(ref, () => ({
        getSelectedObjectId: getSelectedObjectId,
        selectedRows: selectedRows
    }));

    var storageKey = props.name ? props.name : props.entityName ? props.entityName : props.API && props.API.entityName ? props.API.entityName : null;
    storageKey = storageKey ? 'setting-grid-' + storageKey : undefined;

    return (
        <AntGridScope segment={buildGridScopeSegment('setting', props.name || props.entityName || (props.API && props.API.entityName) || props.table)}>
            <AntGrid
                ref={grid}
                session={props.session}
                API={props.API}
                url={props.url}
                table={props.table}
                dataSourceHelper={this}
                entityName={props.entityName}
                entityDisplay={props.entityDisplay}
                storageKey={storageKey}
                keyExpr={props.keyExpr}
                loadFunc={props.loadFunc}
                remotePaging={props.remotePaging}
                updateMode={props.updateMode}
                isSearching={props.isSearching !== undefined ? props.isSearching : false}
                search={props.search}
                searchConditions={props.searchConditions}
                searchFields={props.searchFields}
                sortable={props.sortable}
                selectable={props.selectable}
                selectionMode={props.selectionMode}
                defaultPageSize={props.defaultPageSize}
                allowedPageSizes={props.allowedPageSizes}
                // pagerHideable={true}
                columns={props.columns}
                fields={props.fields}
                cellStyles={props.cellStyles}
                cellRenders={props.cellRenders}
                cellContext={props.cellContext}
                rowStyles={props.rowStyles}
                showFilterGroups={props.showFilterGroups}
                showRowActions={props.showRowActions}
                rowActionPack={props.rowActionPack}
                rowActions={props.rowActions}
                rowActionWidth={props.rowActionWidth}
                rowActionsDisplay={props.rowActionsDisplay}
                rowActionPrimaryActions={props.rowActionPrimaryActions}
                batchActions={props.batchActions}
                autoBatchActions={props.autoBatchActions}
                onBatchExecuted={props.onBatchExecuted}
                actionItems={props.actionItems}
                canEditAction={props.canEditAction}
                canDeleteAction={props.canDeleteAction}
                edit={props.edit}
                add={props.add}
                delete={props.delete}
                import={props.import}
                showActionBar={props.showActionBar}
                showRefresh={true}
                showSelectAll={!props.remotePaging}
                showEdit={props.showEdit}
                showDelete={props.showDelete !== undefined ? props.showDelete : true}
                showAdd={props.showAdd}
                showImport={props.showImport}
                showDownload={props.showDownload}
                showDetail={props.showDetail}
                showIndex={props.showIndex}
                // showFilterBySelected={props.showFilterBySelected !== undefined ? props.showFilterBySelected : true}
                showFilterBySelected={false}
                showFieldChooser={props.showFieldChooser}
                showSearchBar={props.showSearchBar}
                searchBarWidth={props.searchBarWidth}
                locationRefresh={props.locationRefresh}
                locationEdit={props.locationEdit}
                locationDelete={props.locationDelete}
                locationAdd={props.locationAdd}
                locationFilterBySelected={props.locationFilterBySelected}
                locationImport={props.locationImport}
                locationDownload={props.locationDownload}
                locationSearchBar={props.locationSearchBar}
                onRowDblClick={props.onRowDblClick}
                onEdit={props.onEdit}
                onDelete={props.onDelete}
                onImport={props.onImport}
                onAdd={props.onAdd}
                onAction={props.onAction}
                prepareConditions={{ ...props.prepareConditions, isSetting: true }}
                searchCategories1={props.searchCategories1}
                searchCategories2={props.searchCategories2}
                searchCategories3={props.searchCategories3}
                searchCategories4={props.searchCategories4}
                searchCategories5={props.searchCategories5}
                searchCategories6={props.searchCategories6}
                searchCategories7={props.searchCategories7}
                searchCategories8={props.searchCategories8}
                searchCategories9={props.searchCategories9}
                searchCategories10={props.searchCategories10}
            />
        </AntGridScope>
    );
});
